import React from 'react';
import { IconProps } from '@/models/IconProps';

const ArrowUp: React.FC<IconProps> = ({ strokeColor = '#4A4D4E' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
    <path d="M0.5 6.5L6.5 0.5L12.5 6.5" stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ArrowUp;
